import { DEFAULT_GROUP, gql } from "@edreamsodigeo/frontend-api-client";

import { LOGIN_RESPONSE_FRAGMENT } from "../../fragments";
import { AUTH_CHANGE_GROUP, LOGIN_GROUP } from "../../groups";

export const PASSWORD_LOGIN_MUTATION = gql`
  ${LOGIN_RESPONSE_FRAGMENT}
  mutation PasswordLogin($request: PasswordLoginRequest!) 
  @update_groups(groups: "${DEFAULT_GROUP},${AUTH_CHANGE_GROUP},${LOGIN_GROUP},passwordLogin") {
    passwordLogin(request: $request) {
      ...LoginResponseParts
    }
  }
`;

export default PASSWORD_LOGIN_MUTATION;
